import PropTypes from "prop-types";
import React from "react";
import { Pagination as P } from "react-bootstrap";

const Pagination = ({
  boundaryLinks = false,
  size,
  ellipsis = true,
  first = false,
  last = false,
  maxButtons = 0,
  next = false,
  prev = false,
  onSelect,
  page,
  pages,
}) => {
  const renderFirst = () => {
    if (!first) return null;
    return (
      <P.First
        key="first"
        disabled={page === 1}
        onClick={() => onSelect(1)}
        linkStyle={{ color: "gray" }}
      />
    );
  };

  const renderPrev = () => {
    if (!prev) return null;
    return (
      <P.Prev
        key="prev"
        disabled={page === 1}
        onClick={() => page !== 1 && onSelect(page - 1)}
        linkStyle={{ color: "gray" }}
      />
    );
  };

  const renderItems = () => {
    const pageButtons = [];
    let startPage, endPage, hasHiddenPagesAfter;

    if (maxButtons) {
      const hiddenPagesBefore = Math.floor(page - maxButtons / 2);
      startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
      hasHiddenPagesAfter = startPage + maxButtons <= pages;

      if (!hasHiddenPagesAfter) {
        endPage = pages;
        startPage = pages - maxButtons + 1;
        if (startPage < 1) startPage = 1;
      } else {
        endPage = startPage + maxButtons - 1;
      }
    } else {
      startPage = 1;
      endPage = pages;
    }

    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
      pageButtons.push(
        <P.Item
          key={pageNumber}
          active={pageNumber === page}
          onClick={() => onSelect(pageNumber)}
          linkStyle={
            pageNumber === page
              ? { backgroundColor: "#00becd", borderColor: "#00becd" }
              : { color: "gray" }
          }
        >
          {pageNumber}
        </P.Item>,
      );
    }

    if (boundaryLinks && ellipsis && startPage !== 1) {
      pageButtons.unshift(
        <P.Item key="ellipsis-start" disabled>
          …
        </P.Item>,
      );
      pageButtons.unshift(
        <P.Item
          key={1}
          active={false}
          onClick={() => onSelect(1)}
          linkStyle={{ color: "gray" }}
        >
          1
        </P.Item>,
      );
    }

    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
      pageButtons.push(
        <P.Item disabled key="ellipsis-end">
          …
        </P.Item>,
      );
      if (boundaryLinks && endPage !== pages) {
        pageButtons.push(
          <P.Item
            key={pages}
            onClick={() => onSelect(pages)}
            linkStyle={{ color: "gray" }}
          >
            {pages}
          </P.Item>,
        );
      }
    }

    return pageButtons;
  };

  const renderNext = () => {
    if (!next) return null;
    return (
      <P.Next
        key="next"
        disabled={page >= pages}
        onClick={() => page < pages && onSelect(page + 1)}
        linkStyle={{ color: "gray" }}
      />
    );
  };

  const renderLast = () => {
    if (!last) return null;
    return (
      <P.Last
        key="last"
        disabled={page >= pages}
        onClick={() => onSelect(pages)}
        linkStyle={{ color: "gray" }}
      />
    );
  };

  return (
    <P size={size} style={{ lineHeight: 1 }}>
      {renderFirst()}
      {renderPrev()}
      {renderItems()}
      {renderNext()}
      {renderLast()}
    </P>
  );
};

Pagination.propTypes = {
  onSelect: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  boundaryLinks: PropTypes.bool,
  size: PropTypes.string,
  ellipsis: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  maxButtons: PropTypes.number,
  next: PropTypes.bool,
  prev: PropTypes.bool,
};

export default Pagination;
